var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "회사소개",
      "sc": "에프원시큐리티가 여러분의 정보를 함께 보호하겠습니다.",
      "tabActive": "Contact",
      "icon": "/images/sub/visual/sv1-icon.svg",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section pb-28 pb-md-28 pb-lg-54 greeting-bg"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--lg",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("F1 Security")]), _vm._v(" 를 오시는 길 입니다 ")])])], 1), _c('section', {
    staticClass: "pt-0 pt-md-0 pt-lg-0 sub-section--last bg-grey"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3166.354085087934!2d126.88393671564631!3d37.47596983706655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61e13c9bce95%3A0x236b85f21ee492f2!2z7ISc7Jq47Yq567OE7IucIOq4iOyynOq1rCDrsprqvYProZwgMjM0!5e0!3m2!1sko!2skr!4v1663061303355!5m2!1sko!2skr",
      "width": "100%",
      "height": "540",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  }), _c('v-container', [_c('div', {
    staticClass: "radius-xl bg-white border pa-30 pa-md-40 px-lg-60 px-lg-100 mt-n100 info-box",
    attrs: {
      "data-aos": "fade"
    }
  }, [_c('h4', {
    staticClass: "font-size-20 font-size-lg-28 line-height-1 font-weight-bold color-point mb-4 mb-lg-10"
  }, [_vm._v(" F1 Security ")]), _c('h5', {
    staticClass: "sub-tit--sm font-weight-bold mb-16 mb-lg-26"
  }, [_vm._v(" 08513 서울 금천구 벚꽃로 234 에이스하이엔드타워6차 1402호 ")]), _c('div', {
    staticClass: "d-flex flex-column flex-md-row align-md-center"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "color-gray d-inline-block mr-6 mr-lg-12"
  }, [_vm._v("전화번호")]), _vm._v("070-4640-3030 ")]), _c('span', {
    staticClass: "line d-none d-md-block mx-10 mx-lg-20"
  }), _c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "color-gray d-inline-block mr-6 mr-lg-12"
  }, [_vm._v("이메일")]), _vm._v("sales@f1security.co.kr ")])])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }